export const MIME_TYPES = {
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
};



// WEBPACK FOOTER //
// ./src/components/shared/answer-types/file-list/mime-types.js